[
  {
    "tag": "1",
    "name": "Account",
    "type": "char",
    "description": "Account mnemonic as agreed between broker and institution."
  },
  {
    "tag": "2",
    "name": "AdvId",
    "type": "char",
    "description": "Unique identifier of advertisement message.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "3",
    "name": "AdvRefID",
    "type": "char",
    "description": "Reference identifier used with CANCEL and REPLACE transaction types.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "4",
    "name": "AdvSide",
    "type": "char",
    "description": "Broker's side of advertised trade",
    "enum": [
      {
        "value": "B",
        "symbolicName": "Buy",
        "description": "Buy"
      },
      {
        "value": "S",
        "symbolicName": "Sell",
        "description": "Sell"
      },
      {
        "value": "T",
        "symbolicName": "Trade",
        "description": "Trade"
      },
      {
        "value": "X",
        "symbolicName": "Cross",
        "description": "Cross"
      }
    ]
  },
  {
    "tag": "5",
    "name": "AdvTransType",
    "type": "char",
    "description": "Identifies advertisement message transaction type",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "6",
    "name": "AvgPx",
    "type": "float",
    "description": "Calculated average price of all fills on this order."
  },
  {
    "tag": "7",
    "name": "BeginSeqNo",
    "type": "int",
    "description": "Message sequence number of first record in range to be resent"
  },
  {
    "tag": "8",
    "name": "BeginString",
    "type": "char",
    "description": "Identifies beginning of new message and protocol version. ALWAYS FIRST FIELD IN MESSAGE. (Always unencrypted)"
  },
  {
    "tag": "9",
    "name": "BodyLength",
    "type": "int",
    "description": "Message length, in bytes, forward to the CheckSum field. ALWAYS SECOND FIELD IN MESSAGE. (Always unencrypted)"
  },
  {
    "tag": "10",
    "name": "CheckSum",
    "type": "char",
    "description": "Three byte, simple checksum (see Appendix B for description). ALWAYS LAST FIELD IN RECORD; i.e. serves, with the trailing <SOH>, as the end-of-record delimiter. Always defined as three characters. (Always unencrypted)"
  },
  {
    "tag": "11",
    "name": "ClOrdID",
    "type": "char",
    "description": "Unique identifier for Order as assigned by institution. Uniqueness must be guaranteed within a single trading day. Firms which electronically submit multi-day orders should consider embedding a date within the ClOrdID field to assure uniqueness across days."
  },
  {
    "tag": "12",
    "name": "Commission",
    "type": "float",
    "description": "Commission. Note if CommType is percentage, Commission of 5% should be represented as .05."
  },
  {
    "tag": "13",
    "name": "CommType",
    "type": "char",
    "description": "Commission type",
    "enum": [
      {
        "value": "1",
        "symbolicName": "PerUnit",
        "description": "per share"
      },
      {
        "value": "2",
        "symbolicName": "Percent",
        "description": "percentage"
      },
      {
        "value": "3",
        "symbolicName": "Absolute",
        "description": "absolute"
      }
    ]
  },
  {
    "tag": "14",
    "name": "CumQty",
    "type": "int",
    "description": "Total number of shares filled."
  },
  {
    "tag": "15",
    "name": "Currency",
    "type": "char",
    "description": "Identifies currency used for price. Absence of this field is interpreted as the default for the security. It is recommended that systems provide the currency value whenever possible. See Appendix A for information on obtaining valid values."
  },
  {
    "tag": "16",
    "name": "EndSeqNo",
    "type": "int",
    "description": "Message sequence number of last record in range to be resent. If request is for a single record BeginSeqNo = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = \"999999\""
  },
  {
    "tag": "17",
    "name": "ExecID",
    "type": "char",
    "description": "Unique identifier of execution message as assigned by broker (will be 0 (zero) for ExecTransType=3 (Status)).\nUniqueness must be guaranteed within a single trading day or the life of a multi-day order. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "18",
    "name": "ExecInst",
    "type": "char",
    "description": "Instructions for order handling on exchange trading floor. If more than one instruction is applicable to an order, this field can contain multiple instructions separated by space.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "StayOnOfferSide",
        "description": "Stay on offerside"
      },
      {
        "value": "1",
        "symbolicName": "NotHeld",
        "description": "Not held"
      },
      {
        "value": "2",
        "symbolicName": "Work",
        "description": "Work"
      },
      {
        "value": "3",
        "symbolicName": "GoAlong",
        "description": "Go along"
      },
      {
        "value": "4",
        "symbolicName": "OverTheDay",
        "description": "Over the day"
      },
      {
        "value": "5",
        "symbolicName": "Held",
        "description": "Held"
      },
      {
        "value": "6",
        "symbolicName": "ParticipateDoNotInitiate",
        "description": "Participate don't initiate"
      },
      {
        "value": "7",
        "symbolicName": "StrictScale",
        "description": "Strict scale"
      },
      {
        "value": "8",
        "symbolicName": "TryToScale",
        "description": "Try to scale"
      },
      {
        "value": "9",
        "symbolicName": "StayOnBidSide",
        "description": "Stay on bidside"
      },
      {
        "value": "A",
        "symbolicName": "NoCross",
        "description": "No cross (cross is forbidden)"
      },
      {
        "value": "B",
        "symbolicName": "OKToCross",
        "description": "OK to cross"
      },
      {
        "value": "C",
        "symbolicName": "CallFirst",
        "description": "Call first"
      },
      {
        "value": "D",
        "symbolicName": "PercentOfVolume",
        "description": "Percent of volume (indicates that the sender does not want to be all of the volume on the floor vs. a specific percentage)"
      },
      {
        "value": "E",
        "symbolicName": "DoNotIncrease",
        "description": "Do not increase - DNI"
      },
      {
        "value": "F",
        "symbolicName": "DoNotReduce",
        "description": "Do not reduce - DNR"
      },
      {
        "value": "G",
        "symbolicName": "AllOrNone",
        "description": "All or none - AON"
      },
      {
        "value": "I",
        "symbolicName": "InstitutionsOnly",
        "description": "Institutions only"
      },
      {
        "value": "L",
        "symbolicName": "LastPeg",
        "description": "Last peg (last sale)"
      },
      {
        "value": "M",
        "symbolicName": "MidPricePeg",
        "description": "Mid-price peg (midprice of inside quote)"
      },
      {
        "value": "N",
        "symbolicName": "NonNegotiable",
        "description": "Non-negotiable"
      },
      {
        "value": "O",
        "symbolicName": "OpeningPeg",
        "description": "Opening peg"
      },
      {
        "value": "P",
        "symbolicName": "MarketPeg",
        "description": "Market peg"
      },
      {
        "value": "R",
        "symbolicName": "PrimaryPeg",
        "description": "Primary peg (primary market - buy at bid/sell at offer)"
      },
      {
        "value": "S",
        "symbolicName": "Suspend",
        "description": "Suspend"
      },
      {
        "value": "U",
        "symbolicName": "CustomerDisplayInstruction",
        "description": "Customer Display Instruction (Rule11Ac1-1/4)"
      },
      {
        "value": "V",
        "symbolicName": "Netting",
        "description": "Netting (for Forex)"
      }
    ]
  },
  {
    "tag": "19",
    "name": "ExecRefID",
    "type": "char",
    "description": "Reference identifier used with Cancel and Correct transaction types.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "20",
    "name": "ExecTransType",
    "type": "char",
    "description": "Identifies transaction type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "2",
        "symbolicName": "Correct",
        "description": "Correct"
      },
      {
        "value": "3",
        "symbolicName": "Status",
        "description": "Status"
      }
    ]
  },
  {
    "tag": "21",
    "name": "HandlInst",
    "type": "char",
    "description": "Instructions for order handling on Broker trading floor",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AutomatedExecutionNoIntervention",
        "description": "Automated execution order, private, no Broker intervention"
      },
      {
        "value": "2",
        "symbolicName": "AutomatedExecutionInterventionOK",
        "description": "Automated execution order, public, Broker intervention OK"
      },
      {
        "value": "3",
        "symbolicName": "ManualOrder",
        "description": "Manual order, best execution"
      }
    ]
  },
  {
    "tag": "22",
    "name": "IDSource",
    "type": "char",
    "description": "Identifies class of alternative SecurityID",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CUSIP",
        "description": "CUSIP"
      },
      {
        "value": "2",
        "symbolicName": "SEDOL",
        "description": "SEDOL"
      },
      {
        "value": "3",
        "symbolicName": "QUIK",
        "description": "QUIK"
      },
      {
        "value": "4",
        "symbolicName": "ISINNumber",
        "description": "ISIN number"
      },
      {
        "value": "5",
        "symbolicName": "RICCode",
        "description": "RIC code"
      },
      {
        "value": "6",
        "symbolicName": "ISOCurrencyCode",
        "description": "ISO Currency Code"
      },
      {
        "value": "7",
        "symbolicName": "ISOCountryCode",
        "description": "ISO Country Code"
      }
    ]
  },
  {
    "tag": "23",
    "name": "IOIid",
    "type": "char",
    "description": "Unique identifier of IOI message.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "24",
    "name": "IOIOthSvc",
    "type": "char",
    "description": "Indicates if, and on which other services, the indication has been advertised. Each character represents an additional service (e.g. if on Bridge and Autex, field = BA, if only on Autex, field = A)",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Autex",
        "description": "Autex"
      },
      {
        "value": "B",
        "symbolicName": "Bridge",
        "description": "Bridge"
      }
    ]
  },
  {
    "tag": "25",
    "name": "IOIQltyInd",
    "type": "char",
    "description": "Relative quality of indication",
    "enum": [
      {
        "value": "H",
        "symbolicName": "High",
        "description": "High"
      },
      {
        "value": "L",
        "symbolicName": "Low",
        "description": "Low"
      },
      {
        "value": "M",
        "symbolicName": "Medium",
        "description": "Medium"
      }
    ]
  },
  {
    "tag": "26",
    "name": "IOIRefID",
    "type": "char",
    "description": "Reference identifier used with CANCEL and REPLACE, transaction types.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "27",
    "name": "IOIShares",
    "type": "char",
    "description": "Number of shares in numeric or relative size.",
    "enum": [
      {
        "value": "L",
        "symbolicName": "Large",
        "description": "Large"
      },
      {
        "value": "M",
        "symbolicName": "Medium",
        "description": "Medium"
      },
      {
        "value": "S",
        "symbolicName": "Small",
        "description": "Small"
      }
    ]
  },
  {
    "tag": "28",
    "name": "IOITransType",
    "type": "char",
    "description": "Identifies IOI message transaction type",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "29",
    "name": "LastCapacity",
    "type": "char",
    "description": "Broker capacity in order execution",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Agent",
        "description": "Agent"
      },
      {
        "value": "2",
        "symbolicName": "CrossAsAgent",
        "description": "Cross as agent"
      },
      {
        "value": "3",
        "symbolicName": "CrossAsPrincipal",
        "description": "Cross as principal"
      },
      {
        "value": "4",
        "symbolicName": "Principal",
        "description": "Principal"
      }
    ]
  },
  {
    "tag": "30",
    "name": "LastMkt",
    "type": "char",
    "description": "Market of execution for last fill\nValid values:\nSee Appendix C"
  },
  {
    "tag": "31",
    "name": "LastPx",
    "type": "float",
    "description": "Price of this (last) fill. Field not required for ExecTransType = 3 (Status)"
  },
  {
    "tag": "32",
    "name": "LastShares",
    "type": "int",
    "description": "Quantity of shares bought/sold on this (last) fill. Field not required for ExecTransType = 3 (Status)"
  },
  {
    "tag": "33",
    "name": "LinesOfText",
    "type": "int",
    "description": "Identifies number of lines of text body"
  },
  {
    "tag": "34",
    "name": "MsgSeqNum",
    "type": "int",
    "description": "Integer message sequence number."
  },
  {
    "tag": "35",
    "name": "MsgType",
    "type": "char",
    "description": "Defines message type. ALWAYS THIRD FIELD IN MESSAGE. (Always unencrypted)\nNote: A \"U\" as the first character in the MsgType field (i.e. U1, U2, etc) indicates that the message format is privately defined between the sender and receiver.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Heartbeat",
        "description": "Heartbeat"
      },
      {
        "value": "1",
        "symbolicName": "TestRequest",
        "description": "Test Request"
      },
      {
        "value": "2",
        "symbolicName": "ResendRequest",
        "description": "Resend Request"
      },
      {
        "value": "3",
        "symbolicName": "Reject",
        "description": "Reject"
      },
      {
        "value": "4",
        "symbolicName": "SequenceReset",
        "description": "Sequence Reset"
      },
      {
        "value": "5",
        "symbolicName": "Logout",
        "description": "Logout"
      },
      {
        "value": "6",
        "symbolicName": "IOI",
        "description": "Indication of Interest"
      },
      {
        "value": "7",
        "symbolicName": "Advertisement",
        "description": "Advertisement"
      },
      {
        "value": "8",
        "symbolicName": "ExecutionReport",
        "description": "Execution Report"
      },
      {
        "value": "9",
        "symbolicName": "OrderCancelReject",
        "description": "Order Cancel Reject"
      },
      {
        "value": "A",
        "symbolicName": "Logon",
        "description": "Logon"
      },
      {
        "value": "B",
        "symbolicName": "News",
        "description": "News"
      },
      {
        "value": "C",
        "symbolicName": "Email",
        "description": "Email"
      },
      {
        "value": "D",
        "symbolicName": "NewOrderSingle",
        "description": "Order - Single"
      },
      {
        "value": "E",
        "symbolicName": "NewOrderList",
        "description": "Order - List"
      },
      {
        "value": "F",
        "symbolicName": "OrderCancelRequest",
        "description": "Order Cancel Request"
      },
      {
        "value": "G",
        "symbolicName": "OrderCancelReplaceRequest",
        "description": "Order Cancel/Replace Request"
      },
      {
        "value": "H",
        "symbolicName": "OrderStatusRequest",
        "description": "Order Status Request"
      },
      {
        "value": "J",
        "symbolicName": "AllocationInstruction",
        "description": "Allocation"
      },
      {
        "value": "K",
        "symbolicName": "ListCancelRequest",
        "description": "List Cancel Request"
      },
      {
        "value": "L",
        "symbolicName": "ListExecute",
        "description": "List Execute"
      },
      {
        "value": "M",
        "symbolicName": "ListStatusRequest",
        "description": "List Status Request"
      },
      {
        "value": "N",
        "symbolicName": "ListStatus",
        "description": "List Status"
      },
      {
        "value": "P",
        "symbolicName": "AllocationInstructionAck",
        "description": "Allocation ACK"
      },
      {
        "value": "Q",
        "symbolicName": "DontKnowTrade",
        "description": "Dont Know Trade (DK)"
      },
      {
        "value": "R",
        "symbolicName": "QuoteRequest",
        "description": "Quote Request"
      },
      {
        "value": "S",
        "symbolicName": "Quote",
        "description": "Quote"
      },
      {
        "value": "T",
        "symbolicName": "SettlementInstructions",
        "description": "Settlement Instructions"
      }
    ]
  },
  {
    "tag": "36",
    "name": "NewSeqNo",
    "type": "int",
    "description": "New sequence number\nValid values:\n0 - 999999"
  },
  {
    "tag": "37",
    "name": "OrderID",
    "type": "char",
    "description": "Unique identifier for Order as assigned by broker. Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
  },
  {
    "tag": "38",
    "name": "OrderQty",
    "type": "int",
    "description": "Number of shares ordered"
  },
  {
    "tag": "39",
    "name": "OrdStatus",
    "type": "char",
    "description": "Identifies current status of order.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "PartiallyFilled",
        "description": "Partially filled"
      },
      {
        "value": "2",
        "symbolicName": "Filled",
        "description": "Filled"
      },
      {
        "value": "3",
        "symbolicName": "DoneForDay",
        "description": "Done for day"
      },
      {
        "value": "4",
        "symbolicName": "Canceled",
        "description": "Canceled"
      },
      {
        "value": "5",
        "symbolicName": "Replaced",
        "description": "Replaced"
      },
      {
        "value": "6",
        "symbolicName": "PendingCancel",
        "description": "Pending Cancel/Replace"
      },
      {
        "value": "7",
        "symbolicName": "Stopped",
        "description": "Stopped"
      },
      {
        "value": "8",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "9",
        "symbolicName": "Suspended",
        "description": "Suspended"
      },
      {
        "value": "A",
        "symbolicName": "PendingNew",
        "description": "Pending New"
      },
      {
        "value": "B",
        "symbolicName": "Calculated",
        "description": "Calculated"
      },
      {
        "value": "C",
        "symbolicName": "Expired",
        "description": "Expired"
      }
    ]
  },
  {
    "tag": "40",
    "name": "OrdType",
    "type": "char",
    "description": "Order type.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Market",
        "description": "Market"
      },
      {
        "value": "2",
        "symbolicName": "Limit",
        "description": "Limit"
      },
      {
        "value": "3",
        "symbolicName": "Stop",
        "description": "Stop"
      },
      {
        "value": "4",
        "symbolicName": "StopLimit",
        "description": "Stop limit"
      },
      {
        "value": "5",
        "symbolicName": "MarketOnClose",
        "description": "Market on close"
      },
      {
        "value": "6",
        "symbolicName": "WithOrWithout",
        "description": "With or without"
      },
      {
        "value": "7",
        "symbolicName": "LimitOrBetter",
        "description": "Limit or better"
      },
      {
        "value": "8",
        "symbolicName": "LimitWithOrWithout",
        "description": "Limit with or without"
      },
      {
        "value": "9",
        "symbolicName": "OnBasis",
        "description": "On basis"
      },
      {
        "value": "A",
        "symbolicName": "OnClose",
        "description": "On close"
      },
      {
        "value": "B",
        "symbolicName": "LimitOnClose",
        "description": "Limit on close"
      },
      {
        "value": "C",
        "symbolicName": "ForexMarket",
        "description": "Forex - Market"
      },
      {
        "value": "D",
        "symbolicName": "PreviouslyQuoted",
        "description": "Previously quoted"
      },
      {
        "value": "E",
        "symbolicName": "PreviouslyIndicated",
        "description": "Previously indicated"
      },
      {
        "value": "F",
        "symbolicName": "ForexLimit",
        "description": "Forex - Limit"
      },
      {
        "value": "G",
        "symbolicName": "ForexSwap",
        "description": "Forex - Swap"
      },
      {
        "value": "H",
        "symbolicName": "ForexPreviouslyQuoted",
        "description": "Forex - Previously Quoted"
      },
      {
        "value": "P",
        "symbolicName": "Pegged",
        "description": "Pegged (requires ExecInst = L, R, M, P or O)"
      }
    ]
  },
  {
    "tag": "41",
    "name": "OrigClOrdID",
    "type": "char",
    "description": "ClOrdID of the previous order (NOT the initial order of the day) as assigned by the institution, used to identify the previous order in cancel and cancel/replace requests."
  },
  {
    "tag": "42",
    "name": "OrigTime",
    "type": "time",
    "description": "Time of message origination (always expressed in GMT)"
  },
  {
    "tag": "43",
    "name": "PossDupFlag",
    "type": "char",
    "description": "Indicates possible retransmission of message with this sequence number",
    "enum": [
      {
        "value": "N",
        "symbolicName": "OriginalTransmission",
        "description": "Original transmission"
      },
      {
        "value": "Y",
        "symbolicName": "PossibleDuplicate",
        "description": "Possible duplicate"
      }
    ]
  },
  {
    "tag": "44",
    "name": "Price",
    "type": "float",
    "description": "Price per share"
  },
  {
    "tag": "45",
    "name": "RefSeqNum",
    "type": "int",
    "description": "Reference message sequence number"
  },
  {
    "tag": "46",
    "name": "RelatdSym",
    "type": "char",
    "description": "Symbol of issue related to story. Can be repeated within message to identify multiple companies."
  },
  {
    "tag": "47",
    "name": "Rule80A",
    "type": "char",
    "description": "Note that the name of this field is changing to \"OrderCapacity\" as Rule80A is a very US market-specific term. Other world markets need to convey similar information, however, often a subset of the US values. . See the \"Rule80A (aka OrderCapacity) Usage by Market\" appendix for market-specific usage of this field.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "AgencySingleOrder",
        "description": "Agency single order"
      },
      {
        "value": "B",
        "symbolicName": "ShortExemptTransactionAType",
        "description": "Short exempt transaction (refer to A type)"
      },
      {
        "value": "C",
        "symbolicName": "ProprietaryNonAlgo",
        "description": "Program Order, non-index arb, for Member firm/org"
      },
      {
        "value": "D",
        "symbolicName": "ProgramOrderMember",
        "description": "Program Order, index arb, for Member firm/org"
      },
      {
        "value": "E",
        "symbolicName": "ShortExemptTransactionForPrincipal",
        "description": "Registered Equity Market Maker trades"
      },
      {
        "value": "F",
        "symbolicName": "ShortExemptTransactionWType",
        "description": "Short exempt transaction (refer to W type)"
      },
      {
        "value": "H",
        "symbolicName": "ShortExemptTransactionIType",
        "description": "Short exempt transaction (refer to I type)"
      },
      {
        "value": "I",
        "symbolicName": "IndividualInvestor",
        "description": "Individual Investor, single order"
      },
      {
        "value": "J",
        "symbolicName": "ProprietaryAlgo",
        "description": "Program Order, index arb, for individual customer"
      },
      {
        "value": "K",
        "symbolicName": "AgencyAlgo",
        "description": "Program Order, non-index arb, for individual customer"
      },
      {
        "value": "L",
        "symbolicName": "ShortExemptTransactionMemberAffliated",
        "description": "Short exempt transaction for member competing market-maker affiliated with the firm clearing the trade (refer to P and O types)"
      },
      {
        "value": "M",
        "symbolicName": "ProgramOrderOtherMember",
        "description": "Program Order, index arb, for other member"
      },
      {
        "value": "N",
        "symbolicName": "AgentForOtherMember",
        "description": "Program Order, non-index arb, for other member"
      },
      {
        "value": "O",
        "symbolicName": "ProprietaryTransactionAffiliated",
        "description": "Competing dealer trades"
      },
      {
        "value": "P",
        "symbolicName": "Principal",
        "description": "Principal"
      },
      {
        "value": "R",
        "symbolicName": "TransactionNonMember",
        "description": "Competing dealer trades"
      },
      {
        "value": "S",
        "symbolicName": "SpecialistTrades",
        "description": "Specialist trades"
      },
      {
        "value": "T",
        "symbolicName": "TransactionUnaffiliatedMember",
        "description": "Competing dealer trades"
      },
      {
        "value": "U",
        "symbolicName": "AgencyIndexArb",
        "description": "Program Order, index arb, for other agency"
      },
      {
        "value": "W",
        "symbolicName": "AllOtherOrdersAsAgentForOtherMember",
        "description": "All other orders as agent for other member"
      },
      {
        "value": "X",
        "symbolicName": "ShortExemptTransactionMemberNotAffliated",
        "description": "Short exempt transaction for member competing market-maker not affiliated with the firm clearing the trade (refer to W and T types)"
      },
      {
        "value": "Y",
        "symbolicName": "AgencyNonAlgo",
        "description": "Program Order, non-index arb, for other agency"
      },
      {
        "value": "Z",
        "symbolicName": "ShortExemptTransactionNonMember",
        "description": "Short exempt transaction for non-member competing market-maker (refer to A and R types)"
      }
    ]
  },
  {
    "tag": "48",
    "name": "SecurityID",
    "type": "char",
    "description": "CUSIP or other alternate security identifier"
  },
  {
    "tag": "49",
    "name": "SenderCompID",
    "type": "char",
    "description": "Assigned value used to identify firm sending message."
  },
  {
    "tag": "50",
    "name": "SenderSubID",
    "type": "char",
    "description": "Assigned value used to identify specific message originator (desk, trader, etc.)"
  },
  {
    "tag": "52",
    "name": "SendingTime",
    "type": "time",
    "description": "Time of message transmission (always expressed in GMT)"
  },
  {
    "tag": "53",
    "name": "Shares",
    "type": "int",
    "description": "Number of shares"
  },
  {
    "tag": "54",
    "name": "Side",
    "type": "char",
    "description": "Side of order",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Buy",
        "description": "Buy"
      },
      {
        "value": "2",
        "symbolicName": "Sell",
        "description": "Sell"
      },
      {
        "value": "3",
        "symbolicName": "BuyMinus",
        "description": "Buy minus"
      },
      {
        "value": "4",
        "symbolicName": "SellPlus",
        "description": "Sell plus"
      },
      {
        "value": "5",
        "symbolicName": "SellShort",
        "description": "Sell short"
      },
      {
        "value": "6",
        "symbolicName": "SellShortExempt",
        "description": "Sell short exempt"
      },
      {
        "value": "7",
        "symbolicName": "Undisclosed",
        "description": "Undisclosed (valid for IOI message only)"
      },
      {
        "value": "8",
        "symbolicName": "Cross",
        "description": "Cross (orders where counterparty is an exchange, valid for all messages except IOIs)"
      }
    ]
  },
  {
    "tag": "55",
    "name": "Symbol",
    "type": "char",
    "description": "Ticker symbol"
  },
  {
    "tag": "56",
    "name": "TargetCompID",
    "type": "char",
    "description": "Assigned value used to identify receiving firm."
  },
  {
    "tag": "57",
    "name": "TargetSubID",
    "type": "char",
    "description": "Assigned value used to identify specific individual or unit intended to receive message. \"ADMIN\" reserved for administrative messages not intended for a specific user."
  },
  {
    "tag": "58",
    "name": "Text",
    "type": "char",
    "description": "Free format text string\n(Note: this field does not have a specified maximum length)"
  },
  {
    "tag": "59",
    "name": "TimeInForce",
    "type": "char",
    "description": "Specifies how long the order remains in effect. Absence of this field is interpreted as DAY.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Day",
        "description": "Day"
      },
      {
        "value": "1",
        "symbolicName": "GoodTillCancel",
        "description": "Good Till Cancel (GTC)"
      },
      {
        "value": "2",
        "symbolicName": "AtTheOpening",
        "description": "At the Opening (OPG)"
      },
      {
        "value": "3",
        "symbolicName": "ImmediateOrCancel",
        "description": "Immediate or Cancel (OC)"
      },
      {
        "value": "4",
        "symbolicName": "FillOrKill",
        "description": "Fill or Kill (FOK)"
      },
      {
        "value": "5",
        "symbolicName": "GoodTillCrossing",
        "description": "Good Till Crossing (GTX)"
      },
      {
        "value": "6",
        "symbolicName": "GoodTillDate",
        "description": "Good Till Date"
      }
    ]
  },
  {
    "tag": "60",
    "name": "TransactTime",
    "type": "time",
    "description": "Time of execution/order creation (expressed in GMT)"
  },
  {
    "tag": "61",
    "name": "Urgency",
    "type": "char",
    "description": "Urgency flag",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Normal",
        "description": "Normal"
      },
      {
        "value": "1",
        "symbolicName": "Flash",
        "description": "Flash"
      },
      {
        "value": "2",
        "symbolicName": "Background",
        "description": "Background"
      }
    ]
  },
  {
    "tag": "62",
    "name": "ValidUntilTime",
    "type": "time",
    "description": "Indicates expiration time of indication message (always expressed in GMT)"
  },
  {
    "tag": "63",
    "name": "SettlmntTyp",
    "type": "char",
    "description": "Indicates order settlement period. Absence of this field is interpreted as Regular. Regular is defined as the default settlement period for the particular security on the exchange of execution.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Regular",
        "description": "Regular"
      },
      {
        "value": "1",
        "symbolicName": "Cash",
        "description": "Cash"
      },
      {
        "value": "2",
        "symbolicName": "NextDay",
        "description": "Next Day"
      },
      {
        "value": "3",
        "symbolicName": "TPlus2",
        "description": "T+2"
      },
      {
        "value": "4",
        "symbolicName": "TPlus3",
        "description": "T+3"
      },
      {
        "value": "5",
        "symbolicName": "TPlus4",
        "description": "T+4"
      },
      {
        "value": "6",
        "symbolicName": "Future",
        "description": "Future"
      },
      {
        "value": "7",
        "symbolicName": "WhenAndIfIssued",
        "description": "When Issued"
      },
      {
        "value": "8",
        "symbolicName": "SellersOption",
        "description": "Sellers Option"
      },
      {
        "value": "9",
        "symbolicName": "TPlus5",
        "description": "T+ 5"
      }
    ]
  },
  {
    "tag": "64",
    "name": "FutSettDate",
    "type": "date",
    "description": "Specific date of trade settlement in YYYYMMDD format. Required when SettlmntTyp = 6 (Future) or SettlmntTyp = 8 (Sellers Option). (expressed in local time at place of settlement)"
  },
  {
    "tag": "65",
    "name": "SymbolSfx",
    "type": "char",
    "description": "Additional information about the security (e.g. preferred, warrants, etc.). Absence of this field indicates common.\nValid values:\nAs defined in the NYSE Stock and bond Symbol Directory and in the AMEX Fitch Directory"
  },
  {
    "tag": "66",
    "name": "ListID",
    "type": "char",
    "description": "Unique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
  },
  {
    "tag": "67",
    "name": "ListSeqNo",
    "type": "int",
    "description": "Sequence of individual order within list (i.e. ListSeqNo of ListNoOrds, 2 of 25, 3 of 25, . . . )"
  },
  {
    "tag": "68",
    "name": "ListNoOrds",
    "type": "int",
    "description": "Total number of orders within list (i.e. ListSeqNo of ListNoOrds, e.g. 2 of 25, 3 of 25, . . . )"
  },
  {
    "tag": "69",
    "name": "ListExecInst",
    "type": "char",
    "description": "Free format text message containing list handling and execution instructions."
  },
  {
    "tag": "70",
    "name": "AllocID",
    "type": "char",
    "description": "Unique identifier for allocation record.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "71",
    "name": "AllocTransType",
    "type": "char",
    "description": "Identifies allocation transaction type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Replace",
        "description": "Replace"
      },
      {
        "value": "2",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "3",
        "symbolicName": "Preliminary",
        "description": "Preliminary (without MiscFees and NetMoney)"
      },
      {
        "value": "4",
        "symbolicName": "Calculated",
        "description": "Calculated (includes MiscFees and NetMoney)"
      }
    ]
  },
  {
    "tag": "72",
    "name": "RefAllocID",
    "type": "char",
    "description": "Reference identifier to be used with Replace and Cancel AllocTransType records.\n(Prior to FIX 4.1 this field was of type int)"
  },
  {
    "tag": "73",
    "name": "NoOrders",
    "type": "int",
    "description": "Indicates number of orders to be combined for average pricing and allocation."
  },
  {
    "tag": "74",
    "name": "AvgPrxPrecision",
    "type": "int",
    "description": "Indicates number of decimal places to be used for average pricing. Absence of this field indicates that default precision arranged by the broker/institution is to be used."
  },
  {
    "tag": "75",
    "name": "TradeDate",
    "type": "date",
    "description": "Indicates date of trade referenced in this record in YYYYMMDD format. Absence of this field indicates current day (expressed in local time at place of trade)."
  },
  {
    "tag": "76",
    "name": "ExecBroker",
    "type": "char",
    "description": "Identifies executing / give-up broker. Standard NASD market-maker mnemonic is preferred."
  },
  {
    "tag": "77",
    "name": "OpenClose",
    "type": "char",
    "description": "For options only.",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Close",
        "description": "Close"
      },
      {
        "value": "O",
        "symbolicName": "Open",
        "description": "Open"
      }
    ]
  },
  {
    "tag": "78",
    "name": "NoAllocs",
    "type": "int",
    "description": "Number of AllocAccount/AllocShares/ProcessCode instances included in allocation record."
  },
  {
    "tag": "79",
    "name": "AllocAccount",
    "type": "char",
    "description": "Sub-account mnemonic"
  },
  {
    "tag": "80",
    "name": "AllocShares",
    "type": "int",
    "description": "Number of shares to be allocated to specific sub-account"
  },
  {
    "tag": "81",
    "name": "ProcessCode",
    "type": "char",
    "description": "Processing code for sub-account. Absence of this field in AllocAccount / AllocShares / ProcessCode instance indicates regular trade.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Regular",
        "description": "regular"
      },
      {
        "value": "1",
        "symbolicName": "SoftDollar",
        "description": "soft dollar"
      },
      {
        "value": "2",
        "symbolicName": "StepIn",
        "description": "step-in"
      },
      {
        "value": "3",
        "symbolicName": "StepOut",
        "description": "step-out"
      },
      {
        "value": "4",
        "symbolicName": "SoftDollarStepIn",
        "description": "soft-dollar step-in"
      },
      {
        "value": "5",
        "symbolicName": "SoftDollarStepOut",
        "description": "soft-dollar step-out"
      },
      {
        "value": "6",
        "symbolicName": "PlanSponsor",
        "description": "plan sponsor"
      }
    ]
  },
  {
    "tag": "82",
    "name": "NoRpts",
    "type": "int",
    "description": "Total number of reports within series."
  },
  {
    "tag": "83",
    "name": "RptSeq",
    "type": "int",
    "description": "Sequence number of message within report series."
  },
  {
    "tag": "84",
    "name": "CxlQty",
    "type": "int",
    "description": "Total number of shares canceled for this order."
  },
  {
    "tag": "87",
    "name": "AllocStatus",
    "type": "int",
    "description": "Identifies status of allocation.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "accepted (successfully processed)"
      },
      {
        "value": "1",
        "symbolicName": "BlockLevelReject",
        "description": "rejected"
      },
      {
        "value": "2",
        "symbolicName": "AccountLevelReject",
        "description": "partial accept"
      },
      {
        "value": "3",
        "symbolicName": "Received",
        "description": "received (received, not yet processed)"
      }
    ]
  },
  {
    "tag": "88",
    "name": "AllocRejCode",
    "type": "int",
    "description": "Identifies reason for rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UnknownAccount",
        "description": "unknown account(s)"
      },
      {
        "value": "1",
        "symbolicName": "IncorrectQuantity",
        "description": "incorrect quantity"
      },
      {
        "value": "2",
        "symbolicName": "IncorrectAveragegPrice",
        "description": "incorrect average price"
      },
      {
        "value": "3",
        "symbolicName": "UnknownExecutingBrokerMnemonic",
        "description": "unknown executing broker mnemonic"
      },
      {
        "value": "4",
        "symbolicName": "CommissionDifference",
        "description": "commission difference"
      },
      {
        "value": "5",
        "symbolicName": "UnknownOrderID",
        "description": "unknown OrderID"
      },
      {
        "value": "6",
        "symbolicName": "UnknownListID",
        "description": "unknown ListID"
      },
      {
        "value": "7",
        "symbolicName": "OtherSeeText",
        "description": "other"
      }
    ]
  },
  {
    "tag": "89",
    "name": "Signature",
    "type": "data",
    "description": "Electronic signature"
  },
  {
    "tag": "90",
    "name": "SecureDataLen",
    "type": "Length",
    "description": "Length of encrypted message"
  },
  {
    "tag": "91",
    "name": "SecureData",
    "type": "data",
    "description": "Actual encrypted data stream"
  },
  {
    "tag": "92",
    "name": "BrokerOfCredit",
    "type": "char",
    "description": "Broker to receive trade credit"
  },
  {
    "tag": "93",
    "name": "SignatureLength",
    "type": "Length",
    "description": "Number of bytes in signature field."
  },
  {
    "tag": "94",
    "name": "EmailType",
    "type": "char",
    "description": "Email message type.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Reply",
        "description": "Reply"
      },
      {
        "value": "2",
        "symbolicName": "AdminReply",
        "description": "Admin Reply"
      }
    ]
  },
  {
    "tag": "95",
    "name": "RawDataLength",
    "type": "Length",
    "description": "Number of bytes in raw data field."
  },
  {
    "tag": "96",
    "name": "RawData",
    "type": "data",
    "description": "Unformatted raw data, can include bitmaps, word processor documents, etc."
  },
  {
    "tag": "97",
    "name": "PossResend",
    "type": "char",
    "description": "Indicates that message may contain information that has been sent under another sequence number.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "OriginalTransmission",
        "description": "Original transmission"
      },
      {
        "value": "Y",
        "symbolicName": "PossibleResend",
        "description": "Possible resend"
      }
    ]
  },
  {
    "tag": "98",
    "name": "EncryptMethod",
    "type": "int",
    "description": "Method of encryption.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "None",
        "description": "None / other"
      },
      {
        "value": "1",
        "symbolicName": "PKCS",
        "description": "PKCS (proprietary)"
      },
      {
        "value": "2",
        "symbolicName": "DES",
        "description": "DES (ECB mode)"
      },
      {
        "value": "3",
        "symbolicName": "PKCSDES",
        "description": "PKCS/DES (proprietary)"
      },
      {
        "value": "4",
        "symbolicName": "PGPDES",
        "description": "PGP/DES (defunct)"
      },
      {
        "value": "5",
        "symbolicName": "PGPDESMD5",
        "description": "PGP/DES-MD5 (see app note on FIX web site)"
      },
      {
        "value": "6",
        "symbolicName": "PEM",
        "description": "PEM/DES-MD5 (see app note on FIX web site)"
      }
    ]
  },
  {
    "tag": "99",
    "name": "StopPx",
    "type": "float",
    "description": "Price per share"
  },
  {
    "tag": "100",
    "name": "ExDestination",
    "type": "char",
    "description": "Execution destination as defined by institution when order is entered."
  },
  {
    "tag": "102",
    "name": "CxlRejReason",
    "type": "int",
    "description": "Code to identify reason for cancel rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "TooLateToCancel",
        "description": "Too late to cancel"
      },
      {
        "value": "1",
        "symbolicName": "UnknownOrder",
        "description": "Unknown order"
      }
    ]
  },
  {
    "tag": "103",
    "name": "OrdRejReason",
    "type": "int",
    "description": "Code to identify reason for order rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "BrokerCredit",
        "description": "Broker option"
      },
      {
        "value": "1",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol"
      },
      {
        "value": "2",
        "symbolicName": "ExchangeClosed",
        "description": "Exchange closed"
      },
      {
        "value": "3",
        "symbolicName": "OrderExceedsLimit",
        "description": "Order exceeds limit"
      },
      {
        "value": "4",
        "symbolicName": "TooLateToEnter",
        "description": "Too late to enter"
      },
      {
        "value": "5",
        "symbolicName": "UnknownOrder",
        "description": "Unknown Order"
      },
      {
        "value": "6",
        "symbolicName": "DuplicateOrder",
        "description": "Duplicate Order"
      }
    ]
  },
  {
    "tag": "104",
    "name": "IOIQualifier",
    "type": "char",
    "description": "Code to qualify IOI use.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "AllOrNone",
        "description": "All or none"
      },
      {
        "value": "C",
        "symbolicName": "AtTheClose",
        "description": "At the close"
      },
      {
        "value": "I",
        "symbolicName": "InTouchWith",
        "description": "In touch with"
      },
      {
        "value": "L",
        "symbolicName": "Limit",
        "description": "Limit"
      },
      {
        "value": "M",
        "symbolicName": "MoreBehind",
        "description": "More behind"
      },
      {
        "value": "O",
        "symbolicName": "AtTheOpen",
        "description": "At the open"
      },
      {
        "value": "P",
        "symbolicName": "TakingAPosition",
        "description": "Taking a position"
      },
      {
        "value": "Q",
        "symbolicName": "AtTheMarket",
        "description": "At the Market (previously called Current Quote)"
      },
      {
        "value": "S",
        "symbolicName": "PortfolioShown",
        "description": "Portfolio show-n"
      },
      {
        "value": "T",
        "symbolicName": "ThroughTheDay",
        "description": "Through the day"
      },
      {
        "value": "V",
        "symbolicName": "Versus",
        "description": "Versus"
      },
      {
        "value": "W",
        "symbolicName": "Indication",
        "description": "Indication - Working away"
      },
      {
        "value": "X",
        "symbolicName": "CrossingOpportunity",
        "description": "Crossing opportunity"
      },
      {
        "value": "Y",
        "symbolicName": "AtTheMidpoint",
        "description": "At the Midpoint"
      },
      {
        "value": "Z",
        "symbolicName": "PreOpen",
        "description": "Pre-open"
      }
    ]
  },
  {
    "tag": "105",
    "name": "WaveNo",
    "type": "char",
    "description": "Identifier to aid in the management of multiple lists derived from a single, master list."
  },
  {
    "tag": "106",
    "name": "Issuer",
    "type": "char",
    "description": "Company name of security issuer (e.g. International Business Machines)"
  },
  {
    "tag": "107",
    "name": "SecurityDesc",
    "type": "char",
    "description": "Security description."
  },
  {
    "tag": "108",
    "name": "HeartBtInt",
    "type": "int",
    "description": "Heartbeat interval (seconds)"
  },
  {
    "tag": "109",
    "name": "ClientID",
    "type": "char",
    "description": "Firm identifier used in third party-transactions."
  },
  {
    "tag": "110",
    "name": "MinQty",
    "type": "int",
    "description": "Minimum quantity of an order to be executed."
  },
  {
    "tag": "111",
    "name": "MaxFloor",
    "type": "int",
    "description": "Maximum number of shares within an order to be shown on the exchange floor at any given time."
  },
  {
    "tag": "112",
    "name": "TestReqID",
    "type": "char",
    "description": "Identifier included in Test Request message to be returned in resulting Heartbeat"
  },
  {
    "tag": "113",
    "name": "ReportToExch",
    "type": "char",
    "description": "Identifies party of trade responsible for exchange reporting.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "SenderReports",
        "description": "Indicates that party sending message will report trade"
      },
      {
        "value": "Y",
        "symbolicName": "ReceiverReports",
        "description": "Indicates that party receiving message must report trade"
      }
    ]
  },
  {
    "tag": "114",
    "name": "LocateReqd",
    "type": "char",
    "description": "Indicates whether the broker is to locate the stock in conjunction with a short sell order.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "Indicates the broker is not required to locate"
      },
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Indicates the broker is responsible for locating the stock"
      }
    ]
  },
  {
    "tag": "115",
    "name": "OnBehalfOfCompID",
    "type": "char",
    "description": "Assigned value used to identify firm originating message\nif the message was delivered by a third party i.e. the third party firm identifier would be delivered in the SenderCompID field and the firm originating the message in this field."
  },
  {
    "tag": "116",
    "name": "OnBehalfOfSubID",
    "type": "char",
    "description": "Assigned value used to identify specific message originator (i.e. trader) if the message was delivered by a third party"
  },
  {
    "tag": "117",
    "name": "QuoteID",
    "type": "char",
    "description": "Unique identifier for quote"
  },
  {
    "tag": "118",
    "name": "NetMoney",
    "type": "float",
    "description": "Total amount due as the result of the transaction (e.g. for Buy order - principal + commission + fees) reported in currency of execution."
  },
  {
    "tag": "119",
    "name": "SettlCurrAmt",
    "type": "float",
    "description": "Total amount due expressed in settlement currency (includes the effect of the forex transaction)"
  },
  {
    "tag": "120",
    "name": "SettlCurrency",
    "type": "char",
    "description": "Currency code of settlement denomination."
  },
  {
    "tag": "121",
    "name": "ForexReq",
    "type": "char",
    "description": "Indicates request for forex accommodation trade to be executed along with security transaction.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "DoNotExecuteForexAfterSecurityTrade",
        "description": "Do not execute Forex after security trade"
      },
      {
        "value": "Y",
        "symbolicName": "ExecuteForexAfterSecurityTrade",
        "description": "Execute Forex after security trade"
      }
    ]
  },
  {
    "tag": "122",
    "name": "OrigSendingTime",
    "type": "time",
    "description": "Original time of message transmission (always expressed in GMT) when transmitting orders as the result of a resend request."
  },
  {
    "tag": "123",
    "name": "GapFillFlag",
    "type": "char",
    "description": "Indicates that the Sequence Reset message is replacing administrative or application messages which will not be resent.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "SequenceReset",
        "description": "Sequence Reset, ignore MsgSeqNum"
      },
      {
        "value": "Y",
        "symbolicName": "GapFillMessage",
        "description": "Gap Fill message, MsgSeqNum field valid"
      }
    ]
  },
  {
    "tag": "124",
    "name": "NoExecs",
    "type": "int",
    "description": "No of execution record groups to follow."
  },
  {
    "tag": "126",
    "name": "ExpireTime",
    "type": "time",
    "description": "Time/Date of order expiration (always expressed in GMT)"
  },
  {
    "tag": "127",
    "name": "DKReason",
    "type": "char",
    "description": "Reason for execution rejection.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol"
      },
      {
        "value": "B",
        "symbolicName": "WrongSide",
        "description": "Wrong side"
      },
      {
        "value": "C",
        "symbolicName": "QuantityExceedsOrder",
        "description": "Quantity exceeds order"
      },
      {
        "value": "D",
        "symbolicName": "NoMatchingOrder",
        "description": "No matching order"
      },
      {
        "value": "E",
        "symbolicName": "PriceExceedsLimit",
        "description": "Price exceeds limit"
      },
      {
        "value": "Z",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "128",
    "name": "DeliverToCompID",
    "type": "char",
    "description": "Assigned value used to identify the firm targeted to receive the message if the message is delivered by a third party i.e. the third party firm identifier would be delivered in the TargetCompID field and the ultimate receiver firm ID in this field."
  },
  {
    "tag": "129",
    "name": "DeliverToSubID",
    "type": "char",
    "description": "Assigned value used to identify specific message recipient (i.e. trader) if the message is delivered by a third party"
  },
  {
    "tag": "130",
    "name": "IOINaturalFlag",
    "type": "char",
    "description": "Indicates that IOI is the result of an existing agency order or a facilitation position resulting from an agency order, not from principal trading or order solicitation activity.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotNatural",
        "description": "Not natural"
      },
      {
        "value": "Y",
        "symbolicName": "Natural",
        "description": "Natural"
      }
    ]
  },
  {
    "tag": "131",
    "name": "QuoteReqID",
    "type": "char",
    "description": "Unique identifier for quote request"
  },
  {
    "tag": "132",
    "name": "BidPx",
    "type": "float",
    "description": "Bid price/rate"
  },
  {
    "tag": "133",
    "name": "OfferPx",
    "type": "float",
    "description": "Offer price/rate"
  },
  {
    "tag": "134",
    "name": "BidSize",
    "type": "int",
    "description": "Quantity of bid"
  },
  {
    "tag": "135",
    "name": "OfferSize",
    "type": "int",
    "description": "Quantity of offer"
  },
  {
    "tag": "136",
    "name": "NoMiscFees",
    "type": "int",
    "description": "Number of repeating groups of miscellaneous fees"
  },
  {
    "tag": "137",
    "name": "MiscFeeAmt",
    "type": "float",
    "description": "Miscellaneous fee value"
  },
  {
    "tag": "138",
    "name": "MiscFeeCurr",
    "type": "char",
    "description": "Currency of miscellaneous fee"
  },
  {
    "tag": "139",
    "name": "MiscFeeType",
    "type": "char",
    "description": "Indicates type of miscellaneous fee.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Regulatory",
        "description": "Regulatory (e.g. SEC)"
      },
      {
        "value": "2",
        "symbolicName": "Tax",
        "description": "Tax"
      },
      {
        "value": "3",
        "symbolicName": "LocalCommission",
        "description": "Local Commission"
      },
      {
        "value": "4",
        "symbolicName": "ExchangeFees",
        "description": "Exchange Fees"
      },
      {
        "value": "5",
        "symbolicName": "Stamp",
        "description": "Stamp"
      },
      {
        "value": "6",
        "symbolicName": "Levy",
        "description": "Levy"
      },
      {
        "value": "7",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "8",
        "symbolicName": "Markup",
        "description": "Markup"
      }
    ]
  },
  {
    "tag": "140",
    "name": "PrevClosePx",
    "type": "float",
    "description": "Previous closing price of security."
  },
  {
    "tag": "141",
    "name": "ResetSeqNumFlag",
    "type": "char",
    "description": "Indicates that the both sides of the FIX session should reset sequence numbers.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "No"
      },
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Yes, reset sequence numbers"
      }
    ]
  },
  {
    "tag": "142",
    "name": "SenderLocationID",
    "type": "char",
    "description": "Assigned value used to identify specific message originator’s location (i.e. geographic location and/or desk, trader)"
  },
  {
    "tag": "143",
    "name": "TargetLocationID",
    "type": "char",
    "description": "Assigned value used to identify specific message originator’s location (i.e. geographic location and/or desk, trader)"
  },
  {
    "tag": "144",
    "name": "OnBehalfOfLocationID",
    "type": "char",
    "description": "Assigned value used to identify specific message originator’s location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party"
  },
  {
    "tag": "145",
    "name": "DeliverToLocationID",
    "type": "char",
    "description": "Assigned value used to identify specific message originator’s location (i.e. geographic location and/or desk, trader) if the message was delivered by a third party"
  },
  {
    "tag": "146",
    "name": "NoRelatedSym",
    "type": "int",
    "description": "Specifies the number of repeating symbols specified."
  },
  {
    "tag": "147",
    "name": "Subject",
    "type": "char",
    "description": "The subject of an Email message"
  },
  {
    "tag": "148",
    "name": "Headline",
    "type": "char",
    "description": "The headline of a News message"
  },
  {
    "tag": "149",
    "name": "URLLink",
    "type": "char",
    "description": "A URL (Uniform Resource Locator) link to additional information (i.e. http://www.XYZ.com/research.html)"
  },
  {
    "tag": "150",
    "name": "ExecType",
    "type": "char",
    "description": "Describes the specific ExecutionRpt (i.e. Pending Cancel) while OrdStatus will always identify the current order status (i.e. Partially Filled)",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "PartialFill",
        "description": "Partial fill"
      },
      {
        "value": "2",
        "symbolicName": "Fill",
        "description": "Fill"
      },
      {
        "value": "3",
        "symbolicName": "DoneForDay",
        "description": "Done for day"
      },
      {
        "value": "4",
        "symbolicName": "Canceled",
        "description": "Cancelled"
      },
      {
        "value": "5",
        "symbolicName": "Replaced",
        "description": "Replace"
      },
      {
        "value": "6",
        "symbolicName": "PendingCancel",
        "description": "Pending Cancel/Replace"
      },
      {
        "value": "7",
        "symbolicName": "Stopped",
        "description": "Stopped"
      },
      {
        "value": "8",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "9",
        "symbolicName": "Suspended",
        "description": "Suspended"
      },
      {
        "value": "A",
        "symbolicName": "PendingNew",
        "description": "Pending New"
      },
      {
        "value": "B",
        "symbolicName": "Calculated",
        "description": "Calculated"
      },
      {
        "value": "C",
        "symbolicName": "Expired",
        "description": "Expired"
      }
    ]
  },
  {
    "tag": "151",
    "name": "LeavesQty",
    "type": "int",
    "description": "Amount of shares open for further execution. If the OrdStatus is Canceled, DoneForTheDay, Expired, Calculated, or Rejected (in which case the order is no longer active) then LeavesQty could be 0, otherwise LeavesQty = OrderQty - CumQty."
  },
  {
    "tag": "152",
    "name": "CashOrderQty",
    "type": "float",
    "description": "Specifies the approximate order quantity desired in total monetary units vs. as a number of shares. The broker would be responsible for converting and calculating a share quantity (OrderQty) based upon this amount to be used for the actual order and subsequent messages."
  },
  {
    "tag": "153",
    "name": "AllocAvgPx",
    "type": "float",
    "description": "AvgPx for a specific AllocAccount"
  },
  {
    "tag": "154",
    "name": "AllocNetMoney",
    "type": "float",
    "description": "NetMoney for a specific AllocAccount"
  },
  {
    "tag": "155",
    "name": "SettlCurrFxRate",
    "type": "float",
    "description": "Foreign exchange rate used to compute SettlCurrAmount from Currency to SettlCurrency"
  },
  {
    "tag": "156",
    "name": "SettlCurrFxRateCalc",
    "type": "char",
    "description": "Specifies whether or not SettlCurrFxRate should be multiplied or divided."
  },
  {
    "tag": "157",
    "name": "NumDaysInterest",
    "type": "int",
    "description": "Number of Days of Interest for convertible bonds and fixed income"
  },
  {
    "tag": "158",
    "name": "AccruedInterestRate",
    "type": "float",
    "description": "Accrued Interest Rate for convertible bonds and fixed income"
  },
  {
    "tag": "159",
    "name": "AccruedInterestAmt",
    "type": "float",
    "description": "Amount of Accrued Interest for convertible bonds and fixed income"
  },
  {
    "tag": "160",
    "name": "SettlInstMode",
    "type": "char",
    "description": "Indicates mode used for Settlement Instructions",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Default",
        "description": "Default"
      },
      {
        "value": "1",
        "symbolicName": "StandingInstructionsProvided",
        "description": "Standing Instructions Provided"
      },
      {
        "value": "2",
        "symbolicName": "SpecificAllocationAccountOverriding",
        "description": "Specific Allocation Account Overriding"
      },
      {
        "value": "3",
        "symbolicName": "SpecificAllocationAccountStanding",
        "description": "Specific Allocation Account Standing"
      }
    ]
  },
  {
    "tag": "161",
    "name": "AllocText",
    "type": "char",
    "description": "Free format text related to a specific AllocAccount."
  },
  {
    "tag": "162",
    "name": "SettlInstID",
    "type": "char",
    "description": "Unique identifier for Settlement Instructions record."
  },
  {
    "tag": "163",
    "name": "SettlInstTransType",
    "type": "char",
    "description": "Settlement Instructions message transaction type",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "164",
    "name": "EmailThreadID",
    "type": "char",
    "description": "Unique identifier for an email thread (new and chain of replies)"
  },
  {
    "tag": "165",
    "name": "SettlInstSource",
    "type": "char",
    "description": "Indicates source of Settlement Instructions",
    "enum": [
      {
        "value": "1",
        "symbolicName": "BrokerCredit",
        "description": "Brokers Instructions"
      },
      {
        "value": "2",
        "symbolicName": "Institution",
        "description": "Institutions Instructions"
      }
    ]
  },
  {
    "tag": "166",
    "name": "SettlLocation",
    "type": "char",
    "description": "Identifies Settlement Depository or Country Code (ISITC spec)",
    "enum": [
      {
        "value": "CED",
        "symbolicName": "CEDEL",
        "description": "CEDEL"
      },
      {
        "value": "DTC",
        "symbolicName": "DepositoryTrustCompany",
        "description": "Depository Trust Company"
      },
      {
        "value": "EUR",
        "symbolicName": "EuroClear",
        "description": "Euroclear"
      },
      {
        "value": "FED",
        "symbolicName": "FederalBookEntry",
        "description": "Federal Book Entry"
      },
      {
        "value": "ISO Country Code",
        "symbolicName": "LocalMarketSettleLocation",
        "description": "Local Market Settle Location"
      },
      {
        "value": "PNY",
        "symbolicName": "Physical",
        "description": "Physical"
      },
      {
        "value": "PTC",
        "symbolicName": "ParticipantTrustCompany",
        "description": "Participant Trust Company"
      }
    ]
  },
  {
    "tag": "167",
    "name": "SecurityType",
    "type": "char",
    "description": "Indicates type of security (ISITC spec)",
    "enum": [
      {
        "value": "BA",
        "symbolicName": "BankersAcceptance",
        "description": "Bankers Acceptance"
      },
      {
        "value": "CD",
        "symbolicName": "CertificateOfDeposit",
        "description": "Certificate Of Deposit"
      },
      {
        "value": "CMO",
        "symbolicName": "CollateralizedMortgageObligation",
        "description": "Collateralize Mortgage Obligation"
      },
      {
        "value": "CORP",
        "symbolicName": "CorporateBond",
        "description": "Corporate Bond"
      },
      {
        "value": "CP",
        "symbolicName": "CommercialPaper",
        "description": "Commercial Paper"
      },
      {
        "value": "CPP",
        "symbolicName": "CorporatePrivatePlacement",
        "description": "Corporate Private Placement"
      },
      {
        "value": "CS",
        "symbolicName": "CommonStock",
        "description": "Common Stock"
      },
      {
        "value": "FHA",
        "symbolicName": "FederalHousingAuthority",
        "description": "Federal Housing Authority"
      },
      {
        "value": "FHL",
        "symbolicName": "FederalHomeLoan",
        "description": "Federal Home Loan"
      },
      {
        "value": "FN",
        "symbolicName": "FederalNationalMortgageAssociation",
        "description": "Federal National Mortgage Association"
      },
      {
        "value": "FOR",
        "symbolicName": "ForeignExchangeContract",
        "description": "Foreign Exchange Contract"
      },
      {
        "value": "FUT",
        "symbolicName": "Future",
        "description": "Future"
      },
      {
        "value": "GN",
        "symbolicName": "GovernmentNationalMortgageAssociation",
        "description": "Government National Mortgage Association"
      },
      {
        "value": "GOVT",
        "symbolicName": "TreasuriesAgencyDebenture",
        "description": "Treasuries + Agency Debenture"
      },
      {
        "value": "MF",
        "symbolicName": "MutualFund",
        "description": "Mutual Fund"
      },
      {
        "value": "MIO",
        "symbolicName": "MortgageInterestOnly",
        "description": "Mortgage Interest Only"
      },
      {
        "value": "MPO",
        "symbolicName": "MortgagePrincipalOnly",
        "description": "Mortgage Principle Only"
      },
      {
        "value": "MPP",
        "symbolicName": "MortgagePrivatePlacement",
        "description": "Mortgage Private Placement"
      },
      {
        "value": "MPT",
        "symbolicName": "MiscellaneousPassThrough",
        "description": "Miscellaneous Pass-Thru"
      },
      {
        "value": "MUNI",
        "symbolicName": "MunicipalBond",
        "description": "Municipal Bond"
      },
      {
        "value": "NONE",
        "symbolicName": "NoSecurityType",
        "description": "No ISITC Security Type"
      },
      {
        "value": "OPT",
        "symbolicName": "Option",
        "description": "Option"
      },
      {
        "value": "PS",
        "symbolicName": "PreferredStock",
        "description": "Preferred Stock"
      },
      {
        "value": "RP",
        "symbolicName": "RepurchaseAgreement",
        "description": "Repurchase Agreement"
      },
      {
        "value": "RVRP",
        "symbolicName": "ReverseRepurchaseAgreement",
        "description": "Reverse Repurchase Agreement"
      },
      {
        "value": "SL",
        "symbolicName": "StudentLoanMarketingAssociation",
        "description": "Student Loan Marketing Association"
      },
      {
        "value": "TD",
        "symbolicName": "TimeDeposit",
        "description": "Time Deposit"
      },
      {
        "value": "USTB",
        "symbolicName": "USTreasuryBillOld",
        "description": "US Treasury Bill"
      },
      {
        "value": "WAR",
        "symbolicName": "Warrant",
        "description": "Warrant"
      },
      {
        "value": "ZOO",
        "symbolicName": "CatsTigersAndLions",
        "description": "Cats, Tigers & Lions (a real code: US Treasury Receipts)"
      }
    ]
  },
  {
    "tag": "168",
    "name": "EffectiveTime",
    "type": "time",
    "description": "Time the details within the message should take effect (always expressed in GMT)"
  },
  {
    "tag": "169",
    "name": "StandInstDbType",
    "type": "int",
    "description": "Identifies the Standing Instruction database used",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Other",
        "description": "Other"
      },
      {
        "value": "1",
        "symbolicName": "DTCSID",
        "description": "DTC SID"
      },
      {
        "value": "2",
        "symbolicName": "ThomsonALERT",
        "description": "Thomson ALERT"
      },
      {
        "value": "3",
        "symbolicName": "AGlobalCustodian",
        "description": "A Global Custodian (StandInstDbName must be provided)"
      }
    ]
  },
  {
    "tag": "170",
    "name": "StandInstDbName",
    "type": "char",
    "description": "Name of the Standing Instruction database represented with StandInstDbType (i.e. the Global Custodian’s name)."
  },
  {
    "tag": "171",
    "name": "StandInstDbID",
    "type": "char",
    "description": "Unique identifier used on the Standing Instructions database for the Standing Instructions to be referenced."
  },
  {
    "tag": "172",
    "name": "SettlDeliveryType",
    "type": "int",
    "description": "Identifies type of settlement"
  },
  {
    "tag": "173",
    "name": "SettlDepositoryCode",
    "type": "char",
    "description": "Broker’s account code at the depository (i.e. CEDEL ID for CEDEL, FINS for DTC, or Euroclear ID for Euroclear) if SettlLocation is a depository"
  },
  {
    "tag": "174",
    "name": "SettlBrkrCode",
    "type": "char",
    "description": "BIC (Bank Identification Code—Swift managed) code of the broker involved (i.e. for multi-company brokerage firms)"
  },
  {
    "tag": "175",
    "name": "SettlInstCode",
    "type": "char",
    "description": "BIC (Bank Identification Code—Swift managed) code of the institution involved (i.e. for multi-company institution firms)"
  },
  {
    "tag": "176",
    "name": "SecuritySettlAgentName",
    "type": "char",
    "description": "Name of SettlInstSource's local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "177",
    "name": "SecuritySettlAgentCode",
    "type": "char",
    "description": "BIC (Bank Identification Code--Swift managed) code of the SettlInstSource's local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "178",
    "name": "SecuritySettlAgentAcctNum",
    "type": "char",
    "description": "SettlInstSource's account number at local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "179",
    "name": "SecuritySettlAgentAcctName",
    "type": "char",
    "description": "Name of SettlInstSource's account at local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "180",
    "name": "SecuritySettlAgentContactName",
    "type": "char",
    "description": "Name of contact at local agent bank for SettlInstSource's account if SettlLocation is not a depository"
  },
  {
    "tag": "181",
    "name": "SecuritySettlAgentContactPhone",
    "type": "char",
    "description": "Phone number for contact at local agent bank if SettlLocation is not a depository"
  },
  {
    "tag": "182",
    "name": "CashSettlAgentName",
    "type": "char",
    "description": "Name of SettlInstSource's local agent bank if SettlDeliveryType=Free"
  },
  {
    "tag": "183",
    "name": "CashSettlAgentCode",
    "type": "char",
    "description": "BIC (Bank Identification Code--Swift managed) code of the SettlInstSource's local agent bank if SettlDeliveryType=Free"
  },
  {
    "tag": "184",
    "name": "CashSettlAgentAcctNum",
    "type": "char",
    "description": "SettlInstSource's account number at local agent bank if SettlDeliveryType=Free"
  },
  {
    "tag": "185",
    "name": "CashSettlAgentAcctName",
    "type": "char",
    "description": "Name of SettlInstSource's account at local agent bank if SettlDeliveryType=Free"
  },
  {
    "tag": "186",
    "name": "CashSettlAgentContactName",
    "type": "char",
    "description": "Name of contact at local agent bank for SettlInstSource's account if SettlDeliveryType=Free"
  },
  {
    "tag": "187",
    "name": "CashSettlAgentContactPhone",
    "type": "char",
    "description": "Phone number for contact at local agent bank for SettlInstSource's account if SettlDeliveryType=Free"
  },
  {
    "tag": "188",
    "name": "BidSpotRate",
    "type": "float",
    "description": "Bid F/X spot rate."
  },
  {
    "tag": "189",
    "name": "BidForwardPoints",
    "type": "float",
    "description": "Bid F/X forward points added to spot rate. May be a negative value."
  },
  {
    "tag": "190",
    "name": "OfferSpotRate",
    "type": "float",
    "description": "Offer F/X spot rate."
  },
  {
    "tag": "191",
    "name": "OfferForwardPoints",
    "type": "float",
    "description": "Offer F/X forward points added to spot rate. May be a negative value."
  },
  {
    "tag": "192",
    "name": "OrderQty2",
    "type": "float",
    "description": "OrderQty of the future part of a F/X swap order."
  },
  {
    "tag": "193",
    "name": "FutSettDate2",
    "type": "date",
    "description": "FutSettDate of the future part of a F/X swap order."
  },
  {
    "tag": "194",
    "name": "LastSpotRate",
    "type": "float",
    "description": "F/X spot rate."
  },
  {
    "tag": "195",
    "name": "LastForwardPoints",
    "type": "float",
    "description": "F/X forward points added to LastSpotRate. May be a negative value."
  },
  {
    "tag": "196",
    "name": "AllocLinkID",
    "type": "char",
    "description": "Can be used to link two different Allocation messages (each with unique AllocID) together, i.e. for F/X \"Netting\" or \"Swaps\". Should be unique."
  },
  {
    "tag": "197",
    "name": "AllocLinkType",
    "type": "int",
    "description": "Identifies the type of Allocation linkage when AllocLinkID is used.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "FXNetting",
        "description": "F/X Netting"
      },
      {
        "value": "1",
        "symbolicName": "FXSwap",
        "description": "F/X Swap"
      }
    ]
  },
  {
    "tag": "198",
    "name": "SecondaryOrderID",
    "type": "char",
    "description": "Assigned by the party which accepts the order. Can be used to provide the OrderID used by an exchange or executing system."
  },
  {
    "tag": "199",
    "name": "NoIOIQualifiers",
    "type": "int",
    "description": "Number of repeating groups of IOIQualifiers."
  },
  {
    "tag": "200",
    "name": "MaturityMonthYear",
    "type": "MonthYear",
    "description": "Month and Year of the maturity for SecurityType=FUT or SecurityType=OPT.\nFormat: YYYYMM\n(i.e. 199903)"
  },
  {
    "tag": "201",
    "name": "PutOrCall",
    "type": "int",
    "description": "Indicates whether an Option is for a put or call.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Put",
        "description": "Put"
      },
      {
        "value": "1",
        "symbolicName": "Call",
        "description": "Call"
      }
    ]
  },
  {
    "tag": "202",
    "name": "StrikePrice",
    "type": "float",
    "description": "Strike Price for an Option."
  },
  {
    "tag": "203",
    "name": "CoveredOrUncovered",
    "type": "int",
    "description": "Used for options",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Covered",
        "description": "Covered"
      },
      {
        "value": "1",
        "symbolicName": "Uncovered",
        "description": "Uncovered"
      }
    ]
  },
  {
    "tag": "204",
    "name": "CustomerOrFirm",
    "type": "int",
    "description": "Used for options when delivering the order to an execution system/exchange to specify if the order is for a customer or the firm placing the order itself.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Customer",
        "description": "Customer"
      },
      {
        "value": "1",
        "symbolicName": "Firm",
        "description": "Firm"
      }
    ]
  },
  {
    "tag": "205",
    "name": "MaturityDay",
    "type": "DayOfMonth",
    "description": "Day of month used in conjunction with MaturityMonthYear to specify the maturity date for SecurityType=FUT or SecurityType=OPT."
  },
  {
    "tag": "206",
    "name": "OptAttribute",
    "type": "char",
    "description": "Can be used for SecurityType=OPT to identify a particular security."
  },
  {
    "tag": "207",
    "name": "SecurityExchange",
    "type": "char",
    "description": "Market used to help identify a security."
  },
  {
    "tag": "208",
    "name": "NotifyBrokerOfCredit",
    "type": "char",
    "description": "Indicates whether or not details should be communicated to BrokerOfCredit (i.e. step-in broker).",
    "enum": [
      {
        "value": "N",
        "symbolicName": "DetailsShouldNotBeCommunicated",
        "description": "Details should not be communicated"
      },
      {
        "value": "Y",
        "symbolicName": "DetailsShouldBeCommunicated",
        "description": "Details should be communicated"
      }
    ]
  },
  {
    "tag": "209",
    "name": "AllocHandlInst",
    "type": "int",
    "description": "Indicates how the receiver (i.e. third party) of Allocation message should handle/process the account details.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Match",
        "description": "Match"
      },
      {
        "value": "2",
        "symbolicName": "Forward",
        "description": "Forward"
      },
      {
        "value": "3",
        "symbolicName": "ForwardAndMatch",
        "description": "Forward and Match"
      }
    ]
  },
  {
    "tag": "210",
    "name": "MaxShow",
    "type": "int",
    "description": "Maximum number of shares within an order to be shown to other customers (i.e. sent via an IOI)."
  },
  {
    "tag": "211",
    "name": "PegDifference",
    "type": "float",
    "description": "Price difference for a pegged order."
  }
]
